<template>
    <div class="custom-messgae">
        <div class="re-examination" v-if="payload.customType === 'card' && payload.childType !== 'doctorCard'" :style="{ padding: customCardPadding ? '0 48px' : '' }">
            <div v-if="payload.childType === 'recommandMedicine'">
                <div class="re-examination-container">
                    <!-- <div class="container-title med-wrap-title">根据您的病症情况，推荐使用以下药品：</div> -->
                    <div class="advice-title">
                        <span class="advice-img"><img src="../../../assets/image/icon_medrecom.png" alt=""/></span>
                        <span>推荐用药</span>
                    </div>
                    <div>
                        <div class="med-wrap" v-for="(item, index) in commendMedicineList" :key="index">
                            <span class="med-img" v-if="item.imgUrl"><img :src="item.imgUrl" alt=""/></span>
                            <span class="med-img" v-else><img src="../../../assets/image/noGoods.png" alt=""/></span>
                            <span class="med-txt">{{ item.medicineName }}</span>
                            <div class="med-tips">{{ item.specification }}</div>
                            <div v-if="getRecommendAmount(item)" class="med-amount">
                                ×{{ getRecommendAmount(item) }}
                            </div>
                        </div>
                    </div>
                    <div class="med-btn" v-if="isShowBuyButton" @click="checkThird('medicineRecommend', payload.data.recommendID)">立即购药</div>
                </div>
                <div class="under-review top12">建议用药仅供参考，用药前请咨询医生。购药时请认准正规渠道，本次咨询不为药品质量负责。</div>
            </div>
            <div v-else-if="payload.childType === 'inquirySummary'">
                <div class="re-examination-container">
                    <div class="advice-title">
                        <span class="advice-img"><img src="../../../assets/image/icon_advice.png" alt=""/></span>
                        <span>问诊小结</span>
                    </div>
                    <!-- <div class="container-detail">
                        <div class="container-detail-label">初步诊断</div>
                        <div class="container-detail-text">{{ doctorAdviceInfo.initialDiagnosis }}</div>
                    </div> -->
                    <div class="container-detail">
                        <div class="container-detail-label text-color prewrap">{{ doctorAdviceInfo.dealSuggestion }}</div>
                        <!-- <div class="container-detail-text">{{ doctorAdviceInfo.dealSuggestion }}</div> -->
                    </div>
                    <!-- <div class="advice-text">{{payload.data.text}}</div> -->
                </div>
                <div class="under-review top12">医生建议仅供参考，不作为诊断依据。</div>
            </div>
            <div class="re-examination-container" v-else-if="payload.childType === 'patientInfo'">
                <div class="container-title" :class="deviceType == 'alipay' ? 'color-bg-huafu' : ''">
                    <img src="../../../assets/image/icon_patientInfo.png" alt=""/>
                    <span>就诊人信息</span>
                    <span class="review-tips" v-if="patientDetail.isReviewInquiry === 1">复诊</span>
                </div>
                <div class="container-detail">
                    <div class="container-detail-label">患者信息</div>
                    <div class="container-detail-text">{{ patientDetail.info }}</div>
                </div>
                <!-- <div class="container-detail">
          <div class="container-detail-label">身份证号</div>
          <div class="container-detail-text">{{patientDetail.id}}</div>
        </div> -->
                <div class="container-detail" v-if="patientDetail.patientAge <= 6">
                    <div class="container-detail-label">体重(kg)：</div>
                    <div class="container-detail-text">{{ patientDetail.patientWeight }}</div>
                </div>
                <div class="container-detail">
                    <div class="container-detail-label">肝功能：</div>
                    <div class="container-detail-text">{{ patientDetail.liver }}</div>
                </div>
                <div class="container-detail">
                    <div class="container-detail-label">肾功能：</div>
                    <div class="container-detail-text">{{ patientDetail.renal }}</div>
                </div>
                <div
                    class="container-detail"
                    v-if="patientDetail.patientAge >= 18 && patientDetail.patientAge <= 45 && patientDetail.patientSex === '女'"
                >
                    <div class="container-detail-label">妊娠/哺乳/备孕：</div>
                    <div class="container-detail-text">{{ patientDetail.pregnancy }}</div>
                </div>
                <div class="container-detail">
                    <div class="container-detail-label">过敏史：</div>
                    <div class="container-detail-text text-red" v-if="patientDetail.allergyDetail">{{ patientDetail.allergyDetail }}</div>
                    <div class="container-detail-text" v-else>无</div>
                </div>
                <div class="container-detail">
                    <div class="container-detail-label">既往史：</div>
                    <div class="container-detail-text" v-if="patientDetail.sicknessDetail">{{ patientDetail.sicknessDetail }}</div>
                    <div class="container-detail-text" v-else>无</div>
                </div>
                <div class="container-detail">
                    <div class="container-detail-label">病情描述</div>
                    <div class="container-detail-text">{{ patientDetail.disease }}</div>
                </div>
                <!-- <div class="container-detail">
          <div class="container-detail-label">确诊疾病</div>
          <div class="container-detail-text">{{patientDetail.disease}}</div>
        </div> -->
                <!-- <div class="container-detail">
          <div class="container-detail-label">疾病史</div>
          <div class="container-detail-text">{{patientDetail.diseaseHistory}}</div>
        </div> -->
                <!-- <div class="container-detail">
          <div class="container-detail-label">曾经用过</div>
          <div class="container-detail-text">{{patientDetail.recur === 1 ? "是" : "否"}}</div>
        </div> -->
            </div>
            <div class="re-examination-container" v-else-if="payload.childType === 'reviewPass' && serviceType == 0">
                <div class="advice-title" :class="deviceType == 'alipay' ? 'color-bg-huafu' : ''">
                    <span class="advice-img"><img src="../../../assets/image/icon_prescription.png" alt=""/></span>
                    <span>处方单</span>
                </div>
                <div class="container-detail">
                    <div class="container-detail-label">患者</div>
                    <div class="container-detail-text ml48">
                        {{
                            JSON.parse(payload.data).patientName +
                                '（' +
                                (JSON.parse(payload.data).patientSex === 1 ? '男' : '女') +
                                ' ' +
                                JSON.parse(payload.data).patientAge +
                                '岁'
                        }}
                    <!-- 年龄小于1岁展示月龄 -->
                 {{
                    JSON.parse(payload.data).patientMonthAge ? JSON.parse(payload.data).patientMonthAge + '个月）' : '）'
                  }}
                    </div>
                </div>
                <div class="container-detail">
                    <div class="container-detail-label">诊断</div>
                    <div class="container-detail-text ml48">{{ JSON.parse(payload.data).diagnosis }}</div>
                </div>
                <div class="container-btn" @click="onPreview(JSON.parse(payload.data).rpImgFileUrl, JSON.parse(payload.data))">查看详情</div>
                <!-- <span class="med-img" v-if="showViewer"><img :src="JSON.parse(payload.data).rpImgFileUrl" alt=""></span> -->
                <!-- <img
          v-if="showViewer"
          :on-close="closeViewer"
          :url-list="[JSON.parse(payload.data).rpImgFileUrl]"
          index="9999" /> -->
            </div>
            <div class="re-examination-container" v-else-if="payload.childType === 'stampPass' && serviceType == 1">
                <div class="advice-title" :class="deviceType == 'alipay' ? 'color-bg-huafu' : ''">
                    <span class="advice-img"><img src="../../../assets/image/icon_prescription.png" alt=""/></span>
                    <span>处方单</span>
                </div>
                <div class="container-detail">
                    <div class="container-detail-label">患者</div>
                    <div class="container-detail-text ml48">
                        {{
                            JSON.parse(payload.data).patientName +
                                '（' +
                                (JSON.parse(payload.data).patientSex === 1 ? '男' : '女') +
                                ' ' +
                                JSON.parse(payload.data).patientAge +
                                '岁'
                        }}
                         {{
                            JSON.parse(payload.data).patientMonthAge ? JSON.parse(payload.data).patientMonthAge + '个月）' : '）'
                        }}
                    </div>
                </div>
                <div class="container-detail">
                    <div class="container-detail-label">诊断</div>
                    <div class="container-detail-text ml48">{{ JSON.parse(payload.data).diagnosis }}</div>
                </div>
                <div class="container-btn" :class="deviceType == 'alipay' ? 'color-huafu' : ''">
                    <div @click="onPreview(JSON.parse(payload.data).rpImgFileUrl, JSON.parse(payload.data))">查看详情</div>
                    <div v-if="JSON.parse(payload.data).isShowBuyButton" @click="checkThird('requireRp', JSON.parse(payload.data).rpID, JSON.parse(payload.data))">立即购药</div>
                </div>
            </div>
            <!-- <div class="re-examination-container" v-else-if="payload.childType === 'illness'">
                <div class="container-title">
                    <img src="../../../assets/image/icon_disease.png" alt=""/>
                    <span>病情描述</span>
                </div>
                <div class="advice-text">{{illnessDes}}</div>
            </div> -->
            <div v-else-if="payload.childType === 'goods'" class="re-examination-container">
                <div class="container-title" :class="deviceType == 'alipay' ? 'color-bg-huafu' : ''">
                    <img src="../../../assets/image/icon_medrecom.png" alt="" />
                    <span>商品推荐</span>
                </div>
                <div class="goods-card-content">
                    <div class="goods-card-img">
                        <img :src="goodsInfo.goodsImageUrl" alt="" />
                    </div>
                    <div class="goods-card-name">{{ goodsInfo.goodsName }}</div>
                </div>
                <div class="container-btn" @click="goToGoods">查看详情</div>
            </div>
        </div>
        <div class="re-examination" v-else-if="payload.childType === 'doctorCard'">
        <div class="re-examination-container  doctor-card-info" >
            <div class="container-title">
                <div class="container-title-text">
                    <img src="../../../assets/image/icon-doctor-card-info.png" alt="">
                    医生资质信息</div>
                <div class="container-title-text-sub">执业证编号 {{ doctorCardInfo.certification }}</div>
            </div>
            <div class="container-detail">
                <img class="doctor-card-info-img" :src="doctorCardInfo.doctorPhoto" alt=""/>
                <div>
                    <div class="container-detail-label">
                    <span class="name">{{ doctorCardInfo.doctorName }}</span>
                    <span class="section">{{ doctorCardInfo.department }}</span>
                </div>
                <div class="hospital">{{ doctorCardInfo.hospital }}</div>
                </div>
            </div>
        </div>
        </div>
        <div class="under-review" v-else-if="payload.customType === 'hint'">
            {{ payload.data.text || JSON.parse(payload.data).patientText }}
        </div>
        <!-- <div class="under-review" v-if="talkTime">{{talkTime}}</div> -->
        <div class="under-review" v-else-if="payload.childType === 'finish'">
            由于在线咨询，医生仅根据您的沟通和上传的图文资料进行病情判断，不能完全代替面诊，若病情仍未好转，请及时到线下就诊
        </div>
        <div class="under-review" v-else-if="payload.customType === 'rp' && payload.childType === 'reviewReject'">
            药师审方已驳回，医生正在重新开方，请耐心等待
        </div>
        <div class="under-review" v-else-if="payload.customType === 'rp' && payload.childType === 'stampPassTip'">
            处方审核已通过，用药期间如有不适请及时线下就诊
        </div>
        <div class="under-review" v-else-if="payload.customType === 'rp' && payload.childType === 'doctorReject'">
            医生拒绝开方：{{ JSON.parse(payload.data).refuseReason }}
        </div>
        <img v-else-if="payload.customType === 'image' && payload.childType === 'sendImage'" :src="payload.data.url" />
        <!-- <div class="under-review" v-if="cancelTxt">{{ cancelTxt }}</div> -->
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { showToast } from 'vant';
// 公共方法
import { getUrlParams } from '../../../utils/const'
export default {
    name: 'customMessage',
    data() {
        return {
            patientDetail: {
                info: '',
                id: '',
            },
            doctorCardInfo: {}, // 医生卡片信息
            goodsInfo: {}, // 商品信息
            commendMedicineList: [], // 推荐药品
            isShowBuyButton: 0, // 是否展示购药药品
            doctorAdviceInfo: '', // 问诊小结
            illnessDes: '',
            talkTime: '', // 视频时长
            cancelTxt: '',
        }
    },
    props: {
        options: {
            type: Object,
            default: () => {},
        },
        serviceType: {
            type: Number,
            default: 1,
        },
    },
    computed: {
        ...mapGetters(['orderDetail', 'deviceType']),
        payload: function() {
            return JSON.parse(this.options.payload.data)
        },
        customCardPadding() {
            return this.payload.childType === 'stampPass' || this.payload.childType === 'inquirySummary'
        }
    },
    mounted() {
        console.log('payload1111', this.payload)
        if (this.payload.customType === 'card') {
            if (this.payload.childType === 'patientInfo') {
                this.getPatientInfo()
            }
            if (this.payload.childType === 'recommandMedicine') {
                this.getCommendMedicinesInfo()
            }
            if (this.payload.childType === 'inquirySummary') {
                this.getDoctorAdvice()
            }
            if (this.payload.childType === 'illness') {
                this.getIllness()
            }
            if (this.payload.childType === 'doctorCard') {
                this.getDoctorCard()
            }
            if (this.payload.childType === 'goods') {
                this.getGoodsInfo()
            }
        }
        if (this.payload.actionType === 2) {
            // 远端取消通话
            this.cancelTxt = '医生已取消通话'
        }
        // if (this.payload.actionType === 1) { // 获取通话时长
        //   if (typeof this.payload.data === 'string') {
        //     let hangVal = JSON.parse(this.payload.data).data.cmd
        //     if (hangVal && hangVal === 'hangup') {
        //       this.getTalkTime()
        //     }
        //   }
        // }
    },
    methods: {
        async checkThird (type, operateID, data) {
            if (type === 'requireRp') {
                let res = await this.$_http.post(this.$_API.checkRpStatus, { orgId: this.orderDetail.orgID, rpId: data.rpID, bizId: data.bizID })
                if (res.data.status === '1') {
                    this.$toast('处方已撤回，不支持购药');
                    return
                }
            }
            const { bizID, inquiryOrderID } = this.orderDetail;
            // const operateID = this.payload.data.recommendID
            const deviceType = this.deviceType || getUrlParams()['deviceType']
            const params = {
                bizID: bizID,
                inquiryID: inquiryOrderID,
                operateID: operateID,
                requireType: type,
                deviceType: deviceType
            }
            this.$_http
                .post(this.$_API.H5_INQUIRY_POST_CHECKTHIRD, params)
                .then(res => {
                const { url } = res.data;
                if (deviceType === 'wechat') {
                    wx.miniProgram.navigateTo({
                        url
                    });
                } else if (deviceType === 'uniapp') {
                    window.postMessage({
                        data: {
                            action: type,
                            url
                        }
                    }, '*')
                    uni.postMessage({
                        data: {
                            action: type,
                            url
                        }
                    })
                } else {
                    window.location.href = `${url}`;
                }
            });
        },
        // 获取通话时长
        getTalkTime() {
            let getTime = JSON.parse(this.payload.data).call_end
            let h = parseInt(getTime / 3600)
            if (h < 10) {
                h = '0' + h
            }
            let m = parseInt((getTime % 3600) / 60)
            if (m < 10) {
                m = '0' + m
            }
            let s = (getTime % 3600) % 60
            if (s < 10) {
                s = '0' + s
            }
            this.talkTime = `视频时长 ${h}:${m}:${s}`
        },
        // 获取推荐药品信息
        getCommendMedicinesInfo() {
            this.commendMedicineList = JSON.parse(this.payload.data.medicines)
            this.isShowBuyButton = this.payload.data.isShowBuyButton
            // console.log(this.commendMedicineList)
        },
        getRecommendAmount(item) {
            const values = [item.amount, item.medicineAmount, item.recommendQuantity, item.quantity]
            const rawAmount = values.find(value => value !== undefined && value !== null && value !== '')
            const amount = Number(rawAmount)
            return Number.isFinite(amount) && amount > 0 ? Math.trunc(amount) : ''
        },
        // 获取病情描述
        getIllness() {
            this.illnessDes = JSON.parse(this.payload.data).illness
        },
        // 获取问诊小结信息
        getDoctorAdvice() {
            this.doctorAdviceInfo = JSON.parse(this.payload.data)
            // console.log('问诊小结===', this.doctorAdviceInfo)
        },
        getDoctorCard() {
            this.doctorCardInfo = JSON.parse(this.payload.data)
        },
        getGoodsInfo() {
            this.goodsInfo = JSON.parse(this.payload.data)
        },
        goToGoods() {
            const deviceType = this.deviceType || getUrlParams()['deviceType']
            const goodsUrl = this.goodsInfo.goodsUrl
            if (!goodsUrl) return
            const url = goodsUrl.startsWith('/') ? goodsUrl : '/' + goodsUrl
            if (deviceType === 'wechat') {
                wx.miniProgram.navigateTo({
                    url,
                    success: function (res) {
                        console.log('goods navigateTo成功', res)
                    },
                    fail: function (res) {
                        console.log('goods navigateTo失败', res)
                    }
                })
            } else if (deviceType === 'uniapp') {
                window.postMessage({ data: { action: 'goods', url } }, '*')
                uni.postMessage({ data: { action: 'goods', url } })
            } else if (deviceType === 'alipay') {
                my.navigateTo({ url })
            } else {
                window.location.href = url
            }
        },
        getPatientInfo() {
            let data = JSON.parse(this.payload.data)
            // console.log(data)
            this.patientDetail.info = `${data.patientName}，${data.patientSex === 1 ? '男' : '女'}，${data.patientAge}岁 ${data.patientMonthAge ? `${data.patientMonthAge}个月` : ''}`
            // if (data.patientWeight && data.patientWeight !== '0.00') {
            //   this.patientDetail.info += `，${parseFloat(data.patientWeight).toFixed(1)}KG`
            // }
            // this.patientDetail.id = data.patientIdNo.substr(0, 5) + (new Array(data.patientIdNo.length - 9).fill('*').join('')) + data.patientIdNo.substr(data.patientIdNo.length - 4)
            this.patientDetail.patientSex = data.patientSex === 1 ? '男' : '女'
            this.patientDetail.patientAge = data.patientAge
            this.patientDetail.patientWeight = data.patientWeight
            this.patientDetail.liver = data.liver === 0 ? '正常' : '异常'
            this.patientDetail.renal = data.renal === 0 ? '正常' : '异常'
            this.patientDetail.pregnancy = this.getPregnancy(data.pregnancy)
            this.patientDetail.allergyDetail = data.allergyDetail
            this.patientDetail.sicknessDetail = data.sicknessDetail
            this.patientDetail.disease = data.illDesc
            this.patientDetail.diseaseHistory = ''
            this.patientDetail.isReviewInquiry = data.isReviewInquiry
            if (data.pregnancy !== '否') {
                this.patientDetail.diseaseHistory = data.pregnancy
            }
            if (data.liver === '异常') {
                if (this.patientDetail.diseaseHistory !== '') {
                    this.patientDetail.diseaseHistory += '，'
                }
                this.patientDetail.diseaseHistory += '肝功能异常'
            }
            if (data.renal === '异常') {
                if (this.patientDetail.diseaseHistory !== '') {
                    this.patientDetail.diseaseHistory += '，'
                }
                this.patientDetail.diseaseHistory += '肾功能异常'
            }
            if (data.allergyDetail !== '') {
                if (this.patientDetail.diseaseHistory !== '') {
                    this.patientDetail.diseaseHistory += '，'
                }
                this.patientDetail.diseaseHistory += '对' + data.allergyDetail + '过敏'
            }
            if (data.sicknessDetail !== '') {
                if (this.patientDetail.diseaseHistory !== '') {
                    this.patientDetail.diseaseHistory += '，'
                }
                this.patientDetail.diseaseHistory += '有' + data.sicknessDetail + '疾病史'
            }
            this.patientDetail.recur = 1
            // console.log('打印患者信息==', this.patientDetail)
        },
        getPregnancy(pregnancy) {
            switch (pregnancy) {
                case 1:
                    return '备孕'
                case 2:
                    return '妊娠'
                case 3:
                    return '哺乳'
                default:
                    return '否'
            }
        },
        async onPreview(rpUrl, data) {
            let res = await this.$_http.post(this.$_API.checkRpStatus, { orgId: this.orderDetail.orgID, rpId: data.rpID, bizId: data.bizID })
            if (res.data.status === '1') {
                showToast('处方已撤回，不支持查看');
                return
            }
            if (this.deviceType == 'alipay') {
                my.navigateTo({
                    url: `/pages/buy-drug/index?rpID=${data.rpID}`,
                })
                return
            }
            if (this.orderDetail.inquiryType === 0 || this.$route.path === '/specialistWait/waiting') {
                this.$router.push({
                    path: '/rpViewer',
                    query: {
                      rpUrl: rpUrl,
                      path: this.$route.path
                    },
                })
            } else {
                this.$router.replace({
                    path: '/rpViewer',
                    query: {
                      rpUrl: rpUrl,
                      path: this.$route.path
                    },
                })
            }
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../../../styles/common.scss';
.custom-messgae {
    width: 100%;
    display: flex;
    justify-content: center;
}

.re-examination {
    padding: 0 16px;
    width: 100%;
}

.re-examination-container {
    background: white;
    border-radius: 8px;
    overflow: hidden;
    color: #595959;
    box-shadow: 0 1px 2px 0 #c8c9cc, 0 1px 2px 0 #c8c9cc;
}

.container-title {
    font-size: 16px;
    font-weight: 500;
    border-bottom: 1px solid $border;
    background-color: var(--order-primary, var(--primary-color));
    padding: 8px 16px;
    color: #ffffff;
    display: flex;
    align-items: center;
    img {
        width: 18px;
        margin-right: 4px;
        margin-left: 12px;
    }
}
@media  (max-height: 610px) {
  .container-title {
    font-size: 12px;
    padding: 3px 5px;
    img {
      width: 15px;
      margin-right: 4px;
      margin-left: 12px;
    }
  }
}

.review-tips {
    font-size: 12px;
    border: 1px solid #ffffff;
    padding: 0 6px;
    border-radius: 6px;
    margin-left: 8px;
}

.container-detail {
    display: flex;
    padding: 8px 16px;
}
@media  (max-height: 610px) {
  .container-detail {
    display: flex;
    padding: 0px 3px;
  }
  .review-tips {
    font-size: 10px;
    padding: 0 3px;

  }
}

.container-btn {
    color: var(--order-text, #409eff);
    font-size: 16px;
    text-align: center;
    padding: 10px 0;
    // border-top: 1px solid #dbdfe8;
    display: flex;
    align-items: center;
    justify-content: space-around;
    div {
        width: 100%;
        border-right: 0.02667rem solid #dbdfe8;
    }
}

.container-detail-label {
    // width: 56px;
    font-size: 14px;
    color: #8C8C8C;
    min-height: 20px;
    line-height: 20px;
}
@media  (max-height: 610px) {
  .container-detail-label {
    // width: 56px;
    font-size: 10px;

  }
}
.text-color {
    color: #595959;
}

.medicine-name {
    display: flex;
    align-items: center;
}

.container-detail-text {
    flex: 1;
    margin-left: 12px;
    font-size: 14px;
    min-height: 20px;
    line-height: 20px;
    color: #595959;
}

@media  (max-height: 610px) {
  .container-detail-text {

    font-size: 10px;

  }
}
.ml48 {
    margin-left: 48px;
}
.text-red {
    color: #F56C6C
}

.under-review {
    font-size: 12px;
    background: #e7e7e7;
    border-radius: 8px;
    padding: 8px 16px;
    margin: 0 16px;
    word-break: break-all;
}
@media (max-width: 1024px) and (min-width: 768px) {
    .under-review{
        font-size: .28rem!important;
    }
}

.med-wrap {
    display: flex;
    margin: 8px;
    align-items: center;
    color: #595959;
}
.med-type {
    font-size: 12px;
    border: 1px solid #999;
    border-radius: 8px;
    width: 34px;
    display: inline-block;
    text-align: center;
    margin: 0 4px;
}
.med-txt {
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    width: 0;
    min-width: 0;
    flex: 1;
    margin-left: 0;
    padding: 0 4px;
    text-align: center;
    word-break: break-word;
}
.med-img {
    display: inline-block;
    flex: 0 0 40px;
    width: 40px;
    height: 40px;
    img {
        width: 100%;
    }
}
.med-tips {
    min-width: 0;
    flex: 1;
    padding: 0 4px;
    font-size: 14px;
    text-align: center;
    word-break: break-word;
}
.med-amount {
    flex: 0 0 40px;
    font-size: 14px;
    text-align: center;
    white-space: nowrap;
}
.med-wrap-title {
    font-size: 14px;
}
.med-btn {
    color: var(--order-text, #409eff);
    font-size: 16px;
    text-align: center;
    padding: 10px 0;
    // border-top: 1px solid #dbdfe8;
}
.advice-text {
    text-align: justify;
    font-size: 14px;
    color: #595959;
    line-height: 22px;
    padding-top: 6px;
}
.advice-title {
    font-size: 16px;
    padding: 8px 12px;
    display: flex;
    padding-bottom: 10px;
    // justify-content: space-between;
    align-items: center;
    // border-bottom: 1px solid #dbdfe8;
    background: var(--order-primary, var(--primary-color));
    color: #fff;
    font-weight: 500;
    .advice-img {
        width: 18px;
        height: 18px;
        margin-right: 4px;
        img {
            width: 100%;
        }
    }
}
.prewrap {
    white-space: pre-wrap;
}
.top12 {
    margin-top: 12px;
    text-align: center;
}
@media (max-height: 610px) {
  .advice-title {
    font-size: 12px;
    padding: 2px 5px;
    align-items: center;
    background: var(--order-primary, var(--primary-color));
    color: #fff;
    font-weight: 500;
    .advice-img {
      width: 18px;
      height: 18px;
      margin-right: 4px;
      img {
        width: 100%;
      }
    }
  }

  .container-btn {
    color: var(--order-text, #409eff);
    font-size: 12px;
    padding: 3px 0;
  }

}
.doctor-card-info{
    width: 100%;
    .container-title{
        display: flex;
        justify-content: space-between;
        background: #FFF2EA;
        color: #FF8B32;
        height: 26px;
        line-height: 26px;
        font-size: 11px;
        .container-title-text{
            img{
                width: 14px;
                height: 14px;
                margin-right: 1px;
                margin-left: 0;
                vertical-align: middle;
            }
        }
    }
    .container-detail{
        .doctor-card-info-img{
            width: 44px;
            height: 44px;
            border-radius: 44px;
            margin-right: 8px;
        }
        .container-detail-label{
            .name{
                    color: #1D2129;
                    font-size: 15px;
                    &::after{
                        content: '|';
                        margin-left: 6px;
                        color: #4E5969;
                        font-size: 10px;
                    }
                }
            .section{
                color: #4E5969;
                margin-left: 6px;
                font-size: 12px;
            }
        }
        .hospital{
            color: #4e5969;
            font-size: 12px;
            line-height: 18px;
        }
    }
}

.goods-card-content {
    padding: 12px 16px;

    .goods-card-img {
        width: 100%;
        border-radius: 4px;
        overflow: hidden;

        img {
            width: 100%;
            display: block;
            object-fit: cover;
        }
    }

    .goods-card-name {
        font-size: 14px;
        color: #595959;
        line-height: 20px;
        margin-top: 8px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>
